define(["require", "exports", "hypo_elements/Typescripts/Animation/Animation", "jquery"], function (require, exports, Animation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $(function () {
        function moveCta(topzins, target) {
            var cta = $(topzins).find(".topzins-plugin_cta");
            var daten = $(topzins).find(".topzins-plugin_daten");
            var zinsContainer = $(topzins).find(".topzins-plugin_zins-container");
            if (target == "mobile") {
                $(daten).before($(cta));
            }
            else {
                $(cta).appendTo($(zinsContainer));
            }
        }
        $(".topzins-plugin").each(function () {
            var topZinsWidth = $(this).innerWidth() || 0;
            if (topZinsWidth < 660) {
                $(this).addClass("mobile");
                moveCta(this, "mobile");
            }
            (0, Animation_1.registerElement)($(this).find(".topzins-plugin_zinsNumber").data("animation-kind", "number"));
        });
        $(window).on("resize", function () {
            $(".topzins-plugin").each(function () {
                var topZinsWidth = $(this).innerWidth() || 0;
                if (topZinsWidth < 660) {
                    if (!$(this).hasClass("mobile")) {
                        $(this).addClass("mobile");
                        moveCta(this, "mobile");
                    }
                }
                else {
                    if ($(this).hasClass("mobile")) {
                        $(this).removeClass("mobile");
                        moveCta(this, "desktop");
                    }
                }
            });
        });
    });
});
